<div
  class="fixed inset-0 bg-black bg-opacity-50 z-[999] transition-opacity duration-300 top-[3rem]"
  [ngClass]="{ 'md:hidden': !forceMobileLayout }"
  [class.opacity-0]="!isMenuOpen"
  [class.pointer-events-none]="!isMenuOpen"
  [class.opacity-100]="isMenuOpen"
  (click)="closeMenu()"
  [attr.aria-hidden]="true"
></div>

<button
  class="collapse-toggle-btn"
  [class.collapsed]="isDesktopMenuCollapsed"
  (click)="toggleDesktopMenu()"
  [attr.aria-label]="
    isDesktopMenuCollapsed
      ? ('preview.label.expandmenu' | translate)
      : ('preview.label.collapsemenu' | translate)
  "
  [attr.aria-expanded]="!isDesktopMenuCollapsed"
>
  <span></span>
</button>

<nav
  id="preview-sidebar"
  class="sidebar-content min-w-[200px] max-w-[300px] md:w-[17.75rem] bg-primary flex flex-col pl-4 pr-4 pt-4 pb-6 md:pb-8 gap-3 md:gap-4 md:pl-6 md:pr-9 text-[#c4d5b6] overflow-y-auto"
  [class.mobile-menu-open]="isMenuOpen"
  [class.mobile-menu-closed]="!isMenuOpen"
  [class.desktop-collapsed]="isDesktopMenuCollapsed"
  [attr.aria-hidden]="(!isMenuOpen || isDesktopMenuCollapsed) && 'true'"
  role="navigation"
  [attr.aria-label]="'preview.label.previewtitle' | translate"
>
  @let selectPlaceholder =
    "question.singleselectdropdown.placeholder" | translate;

  <!-- Logo -->
  <div class="w-full mb-2 h-6">
    <img
      src="assets/icons/questback-long.svg"
      alt="Questback"
      class="h-6 md:h-8"
    />
  </div>

  <div class="w-full pt-8">
    <label
      class="flex items-center gap-2 text-sm md:text-base sidebar-label pb-2"
      for="preview-mode"
    >
      <i class="fa-solid fa-sliders"></i>

      <span class="label-text">
        {{ "preview.label.testmode" | translate }}
      </span>
      <kendo-svg-icon
        kendoTooltip
        [title]="'preview.label.testmode.tooltip' | translate"
        [icon]="questionCircleIcon"
        size="large"
        class="ml-auto cursor-help opacity-80 hover:opacity-100 preview-tooltip-icon"
        tabindex="0"
      ></kendo-svg-icon>
    </label>
    <ng-select
      labelForId="preview-mode"
      searchable="false"
      [(ngModel)]="previewMode"
      class=""
      (change)="onPreviewModeChange($event)"
      clearable="false"
      [placeholder]="selectPlaceholder"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ getPreviewModeLabelKey(item) | translate }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        {{ getPreviewModeLabelKey(item) | translate }}
      </ng-template>

      <ng-option
        role="option"
        class="flex flex-row"
        [value]="PreviewMode.FreeFlow"
      >
        {{ "preview.label.freenavigation" | translate }}
      </ng-option>

      <ng-option
        role="option"
        class="flex flex-row"
        [value]="PreviewMode.SimulateResponse"
      >
        {{ "preview.label.simulateresponse" | translate }}
      </ng-option>
    </ng-select>
  </div>

  @if (previewMode !== PreviewMode.SimulateResponse) {
    <div
      class="w-full py-1 hidden"
      [ngClass]="{ 'md:block': !forceMobileLayout }"
    >
      <label
        for="goto-question"
        class="flex items-center gap-2 text-sm md:text-base sidebar-label pb-2"
      >
        <i class="fa-solid fa-arrow-right"></i>
        <span class="label-text">
          {{ "preview.label.goto" | translate }}
        </span>
      </label>
      <ng-select
        labelForId="goto-question"
        searchable="false"
        class="custom-wide-panel"
        [(ngModel)]="selectedGoTo"
        (change)="onGoToChange($event)"
        clearable="false"
        [placeholder]="selectPlaceholder"
      >
        <ng-template ng-label-tmp let-item="item">
          @if (item.type === "page") {
            {{ getGoToPageTranslationKey(item.key) | translate }}
          } @else {
            {{ getGoToQuestionName(item.key) }}
          }
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          @if (item.type === "page") {
            {{ getGoToPageTranslationKey(item.key) | translate }}
          } @else {
            {{ getGoToQuestionName(item.key) }}
          }
        </ng-template>

        @for (page of availablePages; track trackByPageName($index, page)) {
          @if (page.name !== "thankyou") {
            @let translatedTitle = page.translationKey | translate;
            <ng-option
              role="option"
              class="flex flex-row"
              [value]="{ type: 'page', key: page.name }"
            >
              <span [title]="translatedTitle">
                {{ translatedTitle }}
              </span>
            </ng-option>
          }
        }

        @for (
          question of questions;
          track trackByQuestionId($index, question);
          let i = $index
        ) {
          <ng-option
            role="option"
            class="flex flex-row"
            [value]="{ type: 'question', key: question.questionId }"
          >
            <span [title]="question.name">
              {{ question.name }}
            </span>
          </ng-option>
        }

        @for (page of availablePages; track trackByPageName($index, page)) {
          @if (page.name === "thankyou") {
            @let translatedTitle = page.translationKey | translate;
            <ng-option
              role="option"
              class="flex flex-row"
              [value]="{ type: 'page', key: page.name }"
            >
              <span [title]="translatedTitle">
                {{ translatedTitle }}
              </span>
            </ng-option>
          }
        }
      </ng-select>
    </div>
  }

  @if (!isMobileOrTablet) {
    <div
      class="w-full py-1 hidden"
      [ngClass]="{ 'md:block': !forceMobileLayout }"
    >
      <label
        class="flex items-center gap-2 text-sm md:text-base sidebar-label pb-2"
        for="device-preview"
      >
        <kendo-svg-icon
          class="pb-1"
          [icon]="devicesOutlineIcon"
          size="xlarge"
        ></kendo-svg-icon>
        <span class="label-text">
          {{ "preview.label.devicepreview" | translate }}
        </span>
      </label>
      <ng-select
        labelForId="device-preview"
        searchable="false"
        class=""
        bindValue="id"
        bindLabel="name"
        [(ngModel)]="selectedDevice"
        (change)="onDeviceChange($event)"
        clearable="false"
        [placeholder]="selectPlaceholder"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ getDeviceLabelKey(item) | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ getDeviceLabelKey(item) | translate }}
        </ng-template>

        <ng-option role="option" class="flex flex-row" [value]="'desktop'">
          {{ "preview.label.desktop" | translate }}
        </ng-option>

        <ng-option role="option" class="flex flex-row" [value]="'mobile'">
          {{ "preview.label.mobile" | translate }}
        </ng-option>

        <ng-option role="option" class="flex flex-row" [value]="'tablet'">
          {{ "preview.label.tablet" | translate }}
        </ng-option>
      </ng-select>
    </div>
  }

  <div class="w-full py-1">
    <label
      class="flex items-center gap-2 text-sm md:text-base sidebar-label pb-2"
      for="rules-in-text"
    >
      <i class="fa-solid fa-list-ul"></i>
      <span class="label-text">
        {{ "preview.label.rulesintext" | translate }}
      </span>
    </label>
    <ng-select
      labelForId="rules-in-text"
      searchable="false"
      class=""
      (change)="onRulesInTextChange($event)"
      [(ngModel)]="rulesInText"
      clearable="false"
      [placeholder]="selectPlaceholder"
    >
      <ng-template ng-label-tmp let-item="item">
        {{ getRulesInTextLabelKey(item) | translate }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        {{ getRulesInTextLabelKey(item) | translate }}
      </ng-template>

      <ng-option role="option" class="flex flex-row" [value]="'true'">
        {{ "preview.label.show" | translate }}
      </ng-option>

      <ng-option role="option" class="flex flex-row" [value]="'false'">
        {{ "preview.label.hide" | translate }}
      </ng-option>
    </ng-select>
  </div>

  @if (previewMode !== PreviewMode.SimulateResponse) {
    <div
      class="w-full py-1 hidden"
      [ngClass]="{ 'md:block': !forceMobileLayout }"
    >
      <label
        class="flex items-center gap-2 text-sm md:text-base sidebar-label pb-2"
        for="language-select"
      >
        <i class="fa-solid fa-globe"></i>
        <span class="label-text">
          {{ "preview.label.language" | translate }}
        </span>
      </label>
      <ng-select
        labelForId="language-select"
        bindValue="code"
        bindLabel="title"
        [items]="languages"
        searchable="false"
        class=""
        (change)="onLanguageChange($event)"
        [(ngModel)]="selectedLanguage"
        clearable="false"
        [placeholder]="selectPlaceholder"
      ></ng-select>
    </div>
  }

  <div class="mt-0 md:mt-auto">
    <div class="preview-button-group">
      <app-button
        [icon]="{
          placement: 'left',
          iconType: Icon.Copy,
          iconColor: SIDEBAR_TEXT_COLOR,
          iconWidth: ICON_SIZE_SMALL,
        }"
        justifyContent="justify-start"
        [customClasses]="BUTTON_BASE_CLASSES"
        [buttonCustomCss]="'flex-1'"
        buttonId="copy-link-button"
        [buttonText]="'preview.label.copylink' | translate"
        (buttonClick)="onCopyLink()"
        class="preview-button"
      ></app-button>

      <app-button
        [icon]="{
          placement: 'left',
          iconType: Icon.Print,
          iconColor: SIDEBAR_TEXT_COLOR,
          iconWidth: ICON_SIZE_SMALL,
        }"
        justifyContent="justify-start"
        [customClasses]="BUTTON_BASE_CLASSES"
        buttonId="print-button"
        [buttonText]="'preview.label.print' | translate"
        [buttonCustomCss]="'flex-1'"
        (buttonClick)="onPrint()"
        class="preview-button"
      ></app-button>
    </div>
  </div>
</nav>
